<!--
 * @File Name: 
 * @Author: WannTonn
 * @Date: 2021-05-14 14:19:52
 * @LastEditor: WannTonn
 * @LastEditTime: 2021-05-14 14:35:08
 * @FilePath: /Fast-front/src/views/system/account/profile/resetPassword.vue
 * @Description: 
-->
<template>
  <el-form
    ref="form"
    :model="user"
    :rules="rules"
    label-width="80px"
    class="resetPwd"
  >
    <el-form-item label="旧密码" prop="oldPassword">
      <el-input
        v-model="user.oldPassword"
        placeholder="请输入旧密码"
        type="password"
      />
      <div class="message">
        如忘记旧密码，可通过登录页，忘记密码功能重置密码
      </div>
    </el-form-item>
    <el-form-item label="新密码" prop="newPassword">
      <el-input
        v-model="user.newPassword"
        placeholder="请输入新密码"
        type="password"
      />
      <div class="message">
        长度要在6到20个字符之间
      </div>
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input
        v-model="user.confirmPassword"
        placeholder="请确认密码"
        type="password"
      />
      <div class="message">
        长度要在6到20个字符之间
      </div>
    </el-form-item>
    <!--  <el-form-item>
      <el-button type="primary" size="mini" @click="submit">保存</el-button>
      <el-button type="danger" size="mini" @click="close">关闭</el-button>
    </el-form-item> -->
  </el-form>
</template>

<script>
import { updateUserPwd } from '@/api/system/user'

export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    const checkPassWord = (rule, value, callBack) => {
      // const regPassWord = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/;
      // const regPassWord = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{6,}$/
      const regPassWord = /^[\da-zA-Z~!@#$%^&*]{6,}$/
      if (regPassWord.test(value)) {
        return callBack()
      }
      callBack(new Error('密码必须为数字、英文字符或标点符号组合'))
    }
    return {
      test: '1test',
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      },
      // 表单校验
      rules: {
        oldPassword: [
          { required: true, message: '旧密码不能为空', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          {
            min: 6,
            max: 20,
            message: '长度在 6 到 20 个字符',
            trigger: 'blur',
          },
          // { validator: checkPassWord, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { required: true, validator: equalToPassword, trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('handleStartRequest')
          updateUserPwd(this.user.oldPassword, this.user.newPassword)
            .then((response) => {
              if (response.code === 200) {
                this.msgSuccess('修改成功')
                this.$emit('handleRequestDone', true)
              }
            })
            .catch(() => {
              this.$emit('handleRequestDone', false)
            })
        }
      })
    },
    close() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.push({ path: '/index' })
    },
  },
}
</script>
<style scoped>
.resetPwd >>> .el-input {
  float: left;
  /* width: 37rem; */
}

.resetPwd >>> .message {
  float: left;
  color: #9ea1af;
  margin-left: 10px;
}
</style>
